export default "<section class=\"page-top-section set-bg\">\n  <div class=\"common-banner\">\n    <h1>{{headerText}}</h1>\n  </div>\n</section>\n"